/**
 * Configuration globale du frontend
 * Contient les URLs des API externes et autres constantes
 */

import { getConfig, isProduction } from '../shared/config/environments';

const CONFIG = {
  // Configuration de l'API
  api: {
    baseUrl: getConfig().api.baseUrl,
    healthCheck: getConfig().api.healthCheck
  },

  // Configuration Supabase
  supabase: {
    url: getConfig().supabase.url,
    key: getConfig().supabase.key
  },

  // Configuration Amazon
  amazon: {
    baseUrl: getConfig().amazon.baseUrl,
    region: getConfig().amazon.region
  },

  // Configuration Qonto
  qonto: {
    baseUrl: getConfig().qonto.baseUrl,
    slug: getConfig().qonto.slug,
    secretKey: getConfig().qonto.secretKey
  },

  // Utilitaires
  isProduction: isProduction(),

  // Timeout par défaut
  DEFAULT_TIMEOUT: 30000,  // 30 secondes
  
  // Chemins des fichiers sur le VPS (pour information uniquement)
  VPS_PATHS: {
    SCRIPTS_PATH: "/root/fbaFollow/scripts",
    LOGS_PATH: "/root/fbaFollow/logs",
    DATA_PATH: "/root/fbaFollow/data",
    EXTRACT_PATH: "/root/fbaFollow/data/extract",
    ANALYZED_PATH: "/root/fbaFollow/data/analyzed",
    SUPPLIERS_PATH: "/root/fbaFollow/data/supplier"
  }
};

export default CONFIG; 